<template>
  <section class="lead-table">
    <b-table
      :data="deals.leads"
      :paginated="isPaginated"
      :per-page="perPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        field="agent"
        label="Agent Name"
        searchable
        sortable
        v-slot="props"
      >
      {{props.row.agent }}
      </b-table-column>
      <b-table-column
        field="fullname"
        label="Customer Name"
        searchable
        sortable
        v-slot="props"
      >
        <router-link :to="'/lead/' + props.row.id">
          {{props.row.fullname }}
        </router-link>
      </b-table-column>
      <b-table-column
        field="carrier"
        label="Carrier"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.carrier || "-" }}
      </b-table-column>
      <b-table-column
        field="policy"
        label="Policy #"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.policy_number || "-" }}
      </b-table-column>
      <b-table-column
        field="app_date"
        label="Submit Date"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.app_date || "-" }}
      </b-table-column>
      <b-table-column
        field="term"
        label="Policy Type"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.term }}
      </b-table-column>
      <b-table-column
        field="coverage_amount"
        label="Coverage Amount"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.coverage_amount ? "$" + props.row.coverage_amount : "-" }}
      </b-table-column>
      <b-table-column
        field="premium"
        label="Monthly Premium"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.premium ? "$" + props.row.premium : "-" }}
      </b-table-column>
      <b-table-column
        field="draft_date"
        label="Due Date"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.draft_date || "-" }}
      </b-table-column>
      <b-table-column
        field="chargeback"
        label="Chargeback"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.chargeback ? "Yes" : "No" || "-" }}
      </b-table-column>
      <b-table-column
        field="s_t"
        label="Status"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.s_t || "-" }}
      </b-table-column>
    </b-table>
    
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DealsTable",
  props: ["user"],
  data() {
    return {
      leads: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      perPage: 20,
      columns: [
        {
          field: "tmp",
          label: "Total Monthly Premium",
          searchable: true,
          sortable: true,
        },
        {
          field: "amp",
          label: "Avg Monthly Premium",
          searchable: true,
          sortable: true,
        },
      ],
    };
  },
  methods: {
    handleClick(payload) {
      event.preventDefault();
      if (!payload.busy) {
        this.$router.push({ path: `/lead/${payload.id}` });
      }
    },
  },
  computed: {
    ...mapGetters({
      deals: "deals/deals",
    }),
    prepareColumns() {
      let fieldsArr = this.columns;
      if (this.user.role_id == 2) {
        fieldsArr = this.columns.filter((e) => e.field !== "agent");
      }
      return fieldsArr;
    },
  },
};
</script>